// extracted by mini-css-extract-plugin
export default {"Highlight":"Highlight_Highlight__BFZ3m","Content":"Highlight_Content__xPdZh","primary":"Highlight_primary__T5-AF","secondary":"Highlight_secondary__EPRvj"};